const bullets = new Swiper("#bullets", {
    loop: true,
  speed: 1000, 
  autoplay: {
    delay: 3000, 
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  pagination: {
    el: ".swiper-pagination", 
    type: "bullets",
    clickable: "clickable"
  }
});
const fraction = new Swiper("#fraction", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  pagination: {
    el: ".swiper-pagination", 
    type: "fraction"
  }
});
const progressbar = new Swiper("#progressbar", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar"
  }
});

document.addEventListener('DOMContentLoaded', function() {
    // 色の配列を定義
    var colors = ['red', 'blue', 'green', 'yellow', 'purple'];
    
    // ドットを取得
    var dots = document.querySelectorAll('.swiper-pagination-bullet');
    
    // 各ドットに色を適用
    dots.forEach(function(dot, index) {
        dot.style.backgroundColor = colors[index % colors.length];
    });
});
